// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrows_arrow__3cwTK","backward":"Arrows_backward__1TON8","forward":"Arrows_forward__2T59S"};